import { Command } from '../Commands';

export class AddMedia extends Command {
  type: string = 'AddMedia';

  priority: number = 100;
}
